angular.module('impactx.approval').service('ApprovalStatus', [ApprovalStatus]);

function ApprovalStatus() {
    var self = this;

    self.getStatusColor = function (status, isExternalStep) {
        var color;
        switch (status) {
            // yellow
            case 1:
            case 17:
                color = '#FFD600';
                break;

            // green
            case 2:
            case 18:
            case 19:
            case 97:
            case 128:
                color = '#8BC34A';
                break;

            // red
            case 3:
            case 6:
            case 9:
            case 10:
            case 16:
            case 48:
                color = '#f48b38';
                break;
            case 64:
            case 80:
            case 81:
            case 96:
                color = '#f44336';
                break;

            // blue
            case 4:
            case 5:
            case 20:
                color = '#64B6F7';
                break;

            // grey
            case 7:
            case 8:
                color = '#BDBDBD';
                break;

            // white (transparent)
            case 0:
            case 32:
            default:
                color = '#FFFFFF';
        }

        // some extra handling to avoid mixing ATI status and PRS export status
        if (isExternalStep) {
            switch (status) {
                case 128:
                case 512:
                case 1024:
                    color = '#8BC34A';
                    break;
                case 2:
                case 8:
                case 256:
                    color = '#FFD600';
                    break;
                case 4:
                case 16:
                case 32:
                case 64:
                case 2048:
                    color = '#f44336';
                    break;
                default:
                    color = '#FFFFFF';
            }
        }

        return color;
    };

    return {
        getStatusColor: self.getStatusColor
    };
}